import React from 'react';
import RadioSelection from '../../common/Product/RadioSelection';

export type RadioOptionsProps = {
  selectedOption: string;
  errorMessage: string;
  optionsList: string[];
  name: string;
  label: string;
  setSelectedOption: (value: string) => void;
};

const RadioOptions = ({
  selectedOption,
  errorMessage,
  optionsList,
  name,
  label,
  setSelectedOption
}: RadioOptionsProps): JSX.Element => {
  const renderOptions = (): JSX.Element[] => {
    return optionsList.map((option, i) => {
      const controlId = `${option.replace(' ', '-')}-${name}-${i}`;

      return (
        <div key={controlId} className='form-check form-check-inline'>
          <input
            data-testid={`test-${controlId}`}
            className='form-check-input'
            type='radio'
            name={name}
            id={controlId}
            value={selectedOption}
            onChange={() => setSelectedOption(option)}
            checked={selectedOption === option}
          />
          <label className='form-check-label' htmlFor={controlId}>
            {option}
          </label>
        </div>
      );
    });
  };

  return (
    <RadioSelection
      show={true}
      selectionName={label}
      error={errorMessage}
      fontDisabledClass=''>
      {renderOptions()}
    </RadioSelection>
  );
};

export default RadioOptions;
